import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { deployUrl } from '../../core/utils/deploy-url';

@Component({
  selector: 'cwo-hourglass',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './hourglass.component.html',
  styleUrl: './hourglass.component.scss'
})
export class HourglassComponent {
  options: AnimationOptions = {
    path: deployUrl('assets/animations/hourglass.json'),
    loop: true,
    autoplay: true,
  };

}